import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../config/httpConfig";

export const getDealCategories = createAsyncThunk(
    "dealUpload/getDealCategories",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get("/api/business/getDealCategory");
            return response?.response?.dealCategory || [];
        } catch (err) {
            return rejectWithValue(err?.message || "Failed to fetch deal categories");
        }
    }
);

export const getEligibleBusinessesThunk = createAsyncThunk(
    "dealUpload/getEligibleBusinesses",
    async (dealCategoryId, { rejectWithValue }) => {
        try {
            const url = dealCategoryId ? `/api/admin/deals/eligible-businesses?dealCategoryId=${dealCategoryId}` : "/api/admin/deals/eligible-businesses";
            const response = await axios.get(url);
            return response.response;
        } catch (err) {
            return rejectWithValue(err?.message || err || "An error occurred");
        }
    }
);

export const invValidate = createAsyncThunk(
  "dealUpload/invValidate",
  async (invList, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/deals/validate/invoice-financing", invList);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const scfValidate = createAsyncThunk(
  "dealUpload/scfValidate",
  async (invList, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/deals/validate/supply-chain", invList);
      return response.response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const invUpload = createAsyncThunk(
  "dealUpload/invUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/deals/invoice-financing", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

export const scfUpload = createAsyncThunk(
  "dealUpload/scfUpload",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post("/api/admin/deals/supply-chain", payload);
      return response;
    } catch (err) {
      return rejectWithValue(err || "An error occurred");
    }
  }
);

const dealUploadSlice = createSlice({
    name: "dealUpload",
    initialState: {
        loading: false,
        businessList: [],
        error: "",
        dealCategories: [],
        dealCategoriesLoading: false,
        dealCategoriesError: null,
        validateLoading: false,
        invoiceSubmitLoading: false,
        success: "",
    },
    extraReducers: (builder) => {
        builder.addCase(getDealCategories.pending, (state) => {
            state.dealCategoriesLoading = true;
            state.dealCategoriesError = null;
        });
        builder.addCase(getDealCategories.fulfilled, (state, action) => {
            state.dealCategoriesLoading = false;
            state.dealCategories = action.payload;
        });
        builder.addCase(getDealCategories.rejected, (state, action) => {
            state.dealCategoriesLoading = false;
            state.dealCategoriesError = action.payload || "Failed to fetch deal categories";
        });

        builder.addCase(getEligibleBusinessesThunk.pending, (state) => {
            state.loading = true;
            state.error = "";
        });
        builder.addCase(getEligibleBusinessesThunk.fulfilled, (state, action) => {
            state.loading = false;
            state.businessList = action.payload || [];
        });
        builder.addCase(getEligibleBusinessesThunk.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch business list";
        });

        builder.addCase(invValidate.pending, (state) => {
            state.validateLoading = true;
            state.error = "";
        });
        builder.addCase(invValidate.fulfilled, (state, action) => {
            state.validateLoading = false;
            state.success = action.payload;
            state.error = "";
        });
        builder.addCase(invValidate.rejected, (state, action) => {
            state.validateLoading = false;
            state.error = action.payload;
        });

        builder.addCase(invUpload.pending, (state) => {
            state.invoiceSubmitLoading = true;
            state.error = "";
        });
        builder.addCase(invUpload.fulfilled, (state, action) => {
            state.invoiceSubmitLoading = false;
            state.error = "";
        });
        builder.addCase(invUpload.rejected, (state, action) => {
            state.invoiceSubmitLoading = false;
            state.error = action.payload;
        });

        builder.addCase(scfValidate.pending, (state) => {
            state.validateLoading = true;
            state.error = "";
        });
        builder.addCase(scfValidate.fulfilled, (state, action) => {
            state.validateLoading = false;
            state.success = action.payload;
            state.error = "";
        });
        builder.addCase(scfValidate.rejected, (state, action) => {
            state.validateLoading = false;
            state.error = action.payload;
        });

        builder.addCase(scfUpload.pending, (state) => {
            state.invoiceSubmitLoading = true;
            state.error = "";
        });
        builder.addCase(scfUpload.fulfilled, (state, action) => {
            state.invoiceSubmitLoading = false;
            state.error = "";
        });
        builder.addCase(scfUpload.rejected, (state, action) => {
            state.invoiceSubmitLoading = false;
            state.error = action.payload;
        });
    },
    reducers: {
        updateSuccessStatus(state) {
            state.success = "";
        },
        updateErrorStatus(state) {
            state.error = "";
        },
    },
});

export const { updateSuccessStatus, updateErrorStatus } = dealUploadSlice.actions;

export default dealUploadSlice.reducer;

